module.exports = __webpack_public_path__ + "img/quiz_imagesmall.f657fe5d.svg";